import {Injectable} from '@angular/core';
import {UserDirectoryApi} from '../api/user-directory.api';
import {UserSearchRequest} from '../model/user-search-request.model';
import { AllUsersSearchRequest } from '../model/all-users-search-request.model';
@Injectable()
export class UserDirectoryService {
    constructor(private userDirectoryApi: UserDirectoryApi) {

    }

    getSearchCriteria = (portalId: number) => this.userDirectoryApi.getSearchCriteria(portalId);

    search = (userSearchRequest: UserSearchRequest) => this.userDirectoryApi.search(userSearchRequest);

    getAllUsers = (searchType:number, data: AllUsersSearchRequest) => this.userDirectoryApi.getAllUsers(searchType, data);
}